<template>
    <a 
      target="_blank"
      :href="book.ExternalLink"
      class="book"
      :class="{
        active: book,
        animate: animate
      }"
    >
      <div class="top"></div>
      <div class="inside"></div>
      <div class="front"></div>
      <div class="right"></div>
    </a>
</template>

<script>
export default {
  name: "Book",
  props: [
    'book'
  ],
  mounted() {
    setInterval(() => {this.animate = !this.animate}, 33000)
  },
  data () {
    return {
      animate: false
    }
  },
}
</script>

<style>
a.book {
  box-sizing: content-box;
  margin-left: auto;
  margin-right: 20px;
  margin-top: -2.5px;
  width: 40px;
  height: 8px;
	transform-style: preserve-3d;
  cursor: default;
}
a.book:hover {
  cursor: default;
}
a.book.active {
  cursor: pointer;
}
a.book.active.animate .top {
  animation: 2s ease alternate openBook;
}
@keyframes openBook {
  0% { transform: skewX(0deg) scaleY(1) }
  50% { transform: skewX(50deg) scaleY(1.5) }
  100% { transform: skewX(0deg) scaleY(1) }
}
a.book.active:hover .top {
  transform: skewX(50deg)  scaleY(1.5);
  transition: transform 0.5s ease;
}
.book div {
  background: linear-gradient(to bottom, var(--dark-yellow-green), var(--dark-green));
}
.book .top {
	width: 40px;
  height: 8px;
  border-bottom: 1px ridge var(--dark-green);
  border-right: 2px solid var(--dark-green);
  transition: transform 0.5s ease;
  transform-origin: bottom left;
  z-index: 1;
}
.book .inside {
  content: '';
  position: absolute;
  top: 0;
  width: 40px;
  height: 8px;
  z-index: -1;
  background: var(--paper);
}
.book .front {
  height: 6px;
  transform-origin: top right;
  transform: skewX(70deg);
  border-bottom: 1px ridge var(--dark-green);
  border-right: 2px ridge var(--dark-green);
}
.book .right {
  margin-left: 40px;
  height: 8px;
  width: 16px;
  transform-origin: top right;
  transform: skewY(20deg) rotateX(180deg);
  background: var(--paper);
  border-left: var(--thin-grey);
  border-right: 3px solid var(--dark-green);
}
</style>


